import React, { useEffect, useRef, useState } from "react";
import img from "../../imgs/chatImage.png";
import { IoIosSend } from "react-icons/io";
import { IoMdArrowRoundBack } from "react-icons/io";
import axios from "axios";
import { Config } from "../../API/config";
import { MessageType, Participant } from "../../types/chat";
import { useCookies } from "react-cookie";
interface MessageProps {
    isChatOpened: (answer: boolean) => void
    reciever: Participant[];
    chatId: string,

}


const Message = (props: MessageProps) => {
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [message, setMessage] = useState("");
    const [ChatMessages, setChatMessages] = useState<MessageType[]>([])
    const senderId = cookies["user-data"]?.id


    const handleMessages = async () => {
        try {
            setIsLoading(true)
            let { data } = await axios.get(`${Config.getChatById}/${props.chatId}`, { withCredentials: true });


            if (data.statusCode == 200) {
                setChatMessages(data.data.messages.reverse());
            }
        } catch (err) {

        }
        finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        handleMessages();
    }, [props.reciever]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [ChatMessages]);

    const handleSend = async () => {
        if (message.trim() !== "") {
            // Create a temporary message object
            const tempMessage: MessageType = {
                _id: Math.random().toString(36).substring(7), // Generate a temporary ID
                content: message,
                senderId: senderId,
                receiverId: props.reciever[0]._id,
                status: "pending", // Temporary status
                read: false,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
            };

            // Optimistically update the state
            setChatMessages(prevMessages => [...prevMessages, tempMessage]);
            setMessage(""); // Clear input

            try {
                let { data } = await axios.post(`${Config.sendMessage}/${props.reciever[0]._id}`, { "content": message }, { withCredentials: true });
                if (data.statusCode == 200) {
                    // Update the messages list with the latest data from the server
                    handleMessages();
                }
            } catch (err) {
                console.error("Message send failed", err);
            }
        }
    };

    return (
        <div className="h-screen flex flex-col bg-gray-100">
            {/* Header Bar */}
            <div className="bg-white p-3 flex items-center shadow-md">
                <button
                    className="md:hidden p-2 text-gray-700"
                    onClick={() => props.isChatOpened(false)}
                >
                    <IoMdArrowRoundBack size={22} />
                </button>
                <img src={props.reciever[0].profileImage ? props.reciever[0].profileImage : img} alt="Receiver Avatar" className="w-10 h-10 rounded-full mx-3" />
                <span className="text-lg font-semibold">{props.reciever[0].name}</span>
            </div>

            <div className="flex-1 p-4 space-y-4 overflow-y-auto">

                {isLoading ? (

                    [...Array(5)].map((_, index) => (
                        <div key={index} className="flex flex-col items-start animate-pulse">
                            <div className="w-40 h-6 bg-gray-300 rounded-lg mb-2"></div>
                            <div className="w-24 h-4 bg-gray-200 rounded-lg"></div>
                        </div>
                    ))
                ) :
                    ChatMessages.map((message) => {
                        const isSender = message.senderId === senderId;


                        const isAdminMessage = message.adminId; // True if adminId exists
                        if (isAdminMessage) {
                            // Admin messages
                            return (
                                <div key={message._id} className="flex flex-col items-start">
                                    <div className="max-w-[75%] p-3 rounded-lg shadow-md text-sm bg-purple-200 text-gray-900 rounded-bl-none relative">
                                        <span className="absolute -top-2 -left-2 bg-purple-500 text-white text-xs px-1 rounded-full">
                                            Admin
                                        </span>
                                        <p>{message.content}</p>
                                        <span className="block text-xs text-gray-500 mt-1 text-right">
                                            {new Date(message.updatedAt).toLocaleTimeString("ar-EG", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </span>
                                    </div>
                                </div>
                            );

                        } else if (isSender) {

                            return (
                                <div key={message._id} className="flex flex-col items-end">
                                    {message.status === "pending" ? (
                                        <div className="bg-orange-200 text-orange-700 px-3 py-1 text-xs rounded-full mb-1 shadow-sm">
                                            في انتظار القبول
                                        </div>
                                    ) : (
                                        <div className="bg-green-200 text-green-700 px-3 py-1 text-xs rounded-full mb-1 shadow-sm">
                                            تم الإرسال
                                        </div>
                                    )}

                                    <div className="max-w-[75%] p-3 rounded-lg shadow-md text-sm bg-primary-200 text-white rounded-br-none relative">
                                        <p>{message.content}</p>
                                        <span className="block text-xs text-gray-300 mt-1 text-right flex items-center gap-1">
                                            {new Date(message.createdAt).toLocaleTimeString("ar-EG", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                            {message.status === "pending" ? (
                                                <span>⏳</span> // Pending
                                            ) : message.read ? (
                                                <span className="text-blue-400">✔✔</span> // Seen (double blue ticks)
                                            ) : (
                                                <span>✔✔</span> // Delivered (double gray ticks)
                                            )}
                                        </span>
                                    </div>
                                </div>
                            );
                        } else {
                            // Receiver (non-admin, non-sender) messages
                            return (
                                <div key={message._id} className="flex flex-col items-start">
                                    <div className="max-w-[75%] p-3 rounded-lg shadow-md text-sm bg-gray-200 text-gray-900 rounded-bl-none">
                                        <p>{message.content}</p>
                                        <span className="block text-xs text-gray-500 mt-1 text-right">
                                            {new Date(message.updatedAt).toLocaleTimeString("ar-EG", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </span>
                                    </div>
                                </div>
                            );
                        }
                    })

                }


                <div ref={messagesEndRef} />
            </div>

            {/* Message Input Bar */}
            <div className="bg-white border-t p-3 flex items-center w-full">
                <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSend()} // Send message on Enter key press
                    placeholder="اكتب رسالتك..."
                    className="flex-1 w-full min-w-0 px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm shadow-sm"
                />
                <button
                    onClick={handleSend}
                    className="ml-3 bg-blue-500 text-white p-3 rounded-full hover:bg-blue-600 transition flex items-center justify-center shadow-md"
                >
                    <IoIosSend size={22} />
                </button>
            </div>
        </div>
    );
};

export default Message;
